export default function request(method, uri, body) {
  return fetch(uri, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    mode: "same-origin",
    credentials: "same-origin",
    body: JSON.stringify(body),
  }).then(function (response) {
    if (response.ok) {
      return response.json()
    } else {
      throw "Request failed"
    }
  })
}
